import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';

import Falist from 'react-icons/lib/fa/align-justify'
import Fagrid from 'react-icons/lib/fa/th-large';

import MovieListItem from "../../../SHARED/components/movielistitem/movielistitem.component";
import CarouselItem from "../../../SHARED/components/carousel/carouselitem.component";
import { getAllMovies, getAllMoviesSeeMore, getRecentMoviesPage, getRecentMoviesPageSeeMore } from '../../../SHARED/actions/movies.actions';
import { storeSelectedMoviesSortBy } from '../../../SHARED/actions/filters.actions';
import Ads from '../ads/ads.component';

class MoviesResults extends Component {

    constructor(props) {
        super(props);

        this.state ={
           view: 'grid'
        };

        this.switchView = this.switchView.bind(this)
    }

    switchView = ( selectedView ) => {
        this.setState({
            view: selectedView
        });
    };

    getCards = () => {
        let adsArray = [
            <Ads
                id="div-gpt-ad-1662463314968-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463314968-0'); googletag.pubads().refresh();});"
            />,
            <Ads
                id="div-gpt-ad-1662463706379-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
            />,
            <Ads
                id="div-gpt-ad-1662463754517-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463754517-0'); googletag.pubads().refresh();});"
            />,
            <Ads
                id="div-gpt-ad-1662463794462-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463794462-0'); googletag.pubads().refresh();});"
            />,

        ];
        if (this.props.cards){
            if (this.props.cards.rows.length !== 0){          
                return this.props.cards.rows.map((card, i) => {    
                    if (this.state.view === 'list') {
                        const addIndex = (Math.ceil(i / 10) % 4) - 1;
                        return (
                            <Fragment key={i}>
                                {i % 10 == 0 && i > 0 ?
                                    <div className="col-12">
                                        {adsArray[addIndex]}
                                    </div> : null}
                                <MovieListItem key={i} card={card} component={this.props.component} />
                            </Fragment>
                        )
                    } else {
                        const addIndex = (Math.ceil(i / 10) % 4) - 1;
                        return (
                            <Fragment key={i}>
                                {i % 10 == 0 && i > 0 ? 
                                    <div className="col-12">
                                        {adsArray[addIndex]}
                                    </div> : null}
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-15 mb-4" key={i}>
                                    <CarouselItem key={i} card={card} component={this.props.component} />
                                </div>
                            </Fragment>
                        )
                    }
                });
            }
            else {
                return <p className="error">Nu există nici un film adăugat</p>;
            }
        }
    };

    handleChange = (event) => {
        if(this.props.component === "allMovies"){
            this.props.selectedFilters ?
            this.props.getAllMovies(`&sort_by=${event.target.value}${this.props.selectedFilters}`) :
            this.props.getAllMovies(`&sort_by=${event.target.value}`);
            this.props.storeSelectedMoviesSortBy(`&sort_by=${event.target.value}`);
        }
        else{
            this.props.selectedFilters ?
            this.props.getRecentMoviesPage(`&sort_by=${event.target.value}${this.props.selectedFilters}`) :
            this.props.getRecentMoviesPage(`&sort_by=${event.target.value}`);
            this.props.storeSelectedMoviesSortBy(`&sort_by=${event.target.value}`);
        }
    }

    seeMore = () => {
        if (this.props.component === "allMovies") { 
            this.props.getAllMoviesSeeMore(
                `${this.props.cards.pager.current_page + 1}${ this.props.selectedFilters ? this.props.selectedFilters: ""}${this.props.selectedSortBy ? this.props.selectedSortBy : ""}`
            );
        }
        else{
            this.props.getRecentMoviesPageSeeMore(
                `${this.props.cards.pager.current_page + 1}${this.props.selectedFilters}${this.props.selectedSortBy ? this.props.selectedSortBy : ""}`
            );
        }
    }

    getSeeMoreCondition = () => {
        if (this.props.cards){
            if(this.props.cards.rows && this.props.cards.pager){
                return <span onClick={this.seeMore}>
                    {this.props.cards.rows.length !== this.props.cards.pager.total_items ? "Vezi mai multe..." : "" }
                </span>
            }
        }
    }

    render() {
        return (
            <Fragment>
                <div className="row order-view-widget">
                    <div className="col-6">
                        <span>Ordonează după:</span>
                        <select onChange={this.handleChange}>
                            <option value="film_release_date_value">Data</option>
                            <option value="film_translated_title_value">Alfabetic</option>
                            <option value="film_rating_imdb_value">Nota IMDB</option>
                        </select>
                    </div>
                    <div className="col-6">
                        <div className="list-grid-view-switch float-right">
                            <div className="row no-gutters insider">
                                <div className={`col-6 ${this.state.view === 'list' ? 'selectedview' : '' }` }>
                                    <Falist onClick={ () => this.switchView('list') }/>
                                </div>
                                <div className={`col-6 ${this.state.view === 'grid' ? 'selectedview' : ''}` }>
                                    <Fagrid onClick={ () => this.switchView('grid') }/>
                                </div>
                            </div>
                        </div>
                        <span className="float-right view-type">Tip afișare: </span>
                    </div>
                </div>
                <div className="movie-results">

                    <div className="row no-gutters">
                        { this.getCards() }
                    </div>

                    <div className="col see-more">
                        {this.getSeeMoreCondition()}
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    selectedFilters: state.filters.movies_filters.selected_filters,
    selectedSortBy: state.filters.movies_filters.selected_sortBy
});
export default connect(mapStateToProps, {
    getAllMovies, 
    getAllMoviesSeeMore, 
    getRecentMoviesPage, 
    getRecentMoviesPageSeeMore, 
    storeSelectedMoviesSortBy
})(MoviesResults);



// WEBPACK FOOTER //
// ./src/FO/components/movieresults/movieresults.component.js